// extracted by mini-css-extract-plugin
module.exports = {"contactInfo_style":"Footer_contactInfo_style__2YWhE"};